import { useIntl } from 'react-intl';

type TranslationValue = string | number | boolean | Date | null | undefined;
type TranslationValues = Record<string, TranslationValue>;

export const useT = () => {
  const intl = useIntl();
  return (
    id: string,
    valuesOrFallback?: TranslationValues | string,
    fallbackOrValues?: string | TranslationValues
  ): string => {
    const values =
      typeof valuesOrFallback === 'string'
        ? (typeof fallbackOrValues === 'object' && fallbackOrValues ? fallbackOrValues : undefined)
        : valuesOrFallback;
    const fallback =
      typeof valuesOrFallback === 'string'
        ? valuesOrFallback
        : typeof fallbackOrValues === 'string'
          ? fallbackOrValues
          : undefined;
    const translated = intl.formatMessage({ id }, values);

    if (translated === id && fallback) {
      return fallback;
    }

    return translated;
  };
};